// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3G9NS","content":"LoadingAlert_content__3A4pT"};